import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * Отрпавить запрос, чтобы изменить статус сотрудника.
 * в Post уходит id и новый status сотрудника
 */

@Injectable()
export class StatusChangeService extends ApiService {
    protected baseUrl = 'card/set-status';
}
